export default [ /*
  {
    header: 'Yönetim Platformu',
  },

  {
    title: 'Yönetim',
    icon: 'PieChartIcon',
    tagVariant: 'light-danger',
    children: [
      {
        title: 'Tarifeler',
        route: 'charts-apex-chart',
      },
      {
        title: 'Tarife İpleri',
        route: 'charts-chartjs',
      },
      {
        title: 'Abone Grupları',
        route: 'charts-echart',
      },
      {
        title: 'Profil Katsayıları',
        route: 'card-basic',
      },
      {
        title: 'Yekdem Birim Fiyatı',
        route: 'card-advance',
      },
      {
        title: 'PUI Birim Fiyatı',
        route: 'card-statistic',
      },
      {
        title: 'Şehirler',
        route: 'card-analytic',
      },
      {
        title: 'Trafo Merkezleri',
        route: 'card-action',
      },
      {
        title: 'Nace Kodları',
        route: 'page-layout-without-menu',
      },
      {
        title: 'Fatura Kalem Tipleri',
        route: 'page-layout-layout-empty',
      },
    ],
  },
  {
    title: 'Kurumlar',
    icon: 'BriefcaseIcon',
    children: [
      {
        title: 'Dağıtım Şirketleri',
        route: 'extensions-sweet-alert',
      },
      {
        title: 'Dağıtım Müdürlükleri',
        route: 'extensions-toastification',
      },
      {
        title: 'Enerji Firmaları',
        route: 'extensions-slider',
      },
      {
        title: 'Belediyeler',
        route: 'extensions-drag-and-drop',
      },

      {
        title: 'Bankalar',
        route: 'extensions-tour',
      },

    ],
  }, */
  {
    header: 'Kullanıcı Yönetimi',
  },
  {
    title: 'Alarmlar',
    route: 'table-bs-table',
    icon: 'BellIcon',
  },
  {
    title: 'Ayarlar',
    route: 'ayarlar',
    icon: 'SettingsIcon',
  },
  {
    title: 'Bize Ulaşın',
    route: 'pages-faq',
    icon: 'HelpCircleIcon',
  },
]
